import React from 'react';
import { CancelViewStore } from 'modules/order/stores';
import { CancelTemplate } from 'themes/modules/order/pages';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new CancelViewStore(rootStore, componentProps), 'cancelViewStore')
class Cancel extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <CancelTemplate {...this.props} />;
	}
}

export default Cancel;
